<template>
  <div id="homeIndex" class="aside-menu-to-content">
    <div class="secondary-menu-container">
      <div class="secondary-menu-title">首页</div>
      <second-menu :secondaryMenuMap="secondaryMenuMap"></second-menu>
    </div>
    <div class="content-container">
      <!-- 二级菜单渲染入口 -->
      <router-view></router-view>
    </div>
  </div>
</template>

<script >
// 页面二级菜单
import SecondMenu from "components/layout/SecondMenu";
import { getDBModuleStatusPermission } from "common/js/storage";
export default {
  data() {
    return {
      secondaryMenuMap: [
        {
          menuName: "系统首页",
          url: "/admin/home/system-index",
          keyword: "ROLE_INDEX_system",
          childrenMenu: []
        },
        {
          menuName: "账号设置",
          url: "/admin/home/account",
          keyword: "ROLE_INDEX_account",
          childrenMenu: []
        },
        {
          menuName: "操作日志",
          url: "/admin/home/log",
          keyword: "ROLE_INDEX_log",
          childrenMenu: []
        },
        {
          menuName: "通知消息",
          url: "/admin/home/message",
          keyword: "ROLE_INDEX_system",
          childrenMenu: []
        },
        {
          menuName: "数据报表",
          url: '/admin/home/data-report',
          keyword: "ROLE_INDEX_data_report",
          childrenMenu: []
        }
      ]
    };
  },
  mounted () {
    if (!getDBModuleStatusPermission().moduleDataReport) {
      for (let i = 0; i < this.secondaryMenuMap.length; i++) {
        if (this.secondaryMenuMap[i].menuName === '数据报表') {
          this.secondaryMenuMap.splice(i, 1)
          i = i - 1;
        }
      }
    }
  },
  methods: {
    onMenuConfirm(url) {
      // 路由跳转
      console.log("路由--", url);
      this.$router.push({
        path: url
      });
    },
  },
  components: {
    SecondMenu
  }
};
</script>

<style lang="scss" scoped>
@import "common/styles/aside-menu-to-content.scss";
</style>
